module.exports = __webpack_public_path__ + "static/img/icon-ding2 (8).2769b26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/icon-ding2 (8).png
// module id = lOgV
// module chunks = 1